import { createContext } from "react";

const PaymentContext = createContext();

export default PaymentContext;